var _rect, _rect2, _path, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    transform: "translate(12 12)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8333 28.9814L39.9999 39.9999M39.9999 39.9999L20.1666 28.9814M39.9999 39.9999L40 62.1667M61 40V30.53C61 29.7305 61 29.3308 60.8822 28.9743C60.778 28.6588 60.6076 28.3693 60.3825 28.125C60.1281 27.8489 59.7786 27.6548 59.0797 27.2665L41.8131 17.6739C41.1513 17.3063 40.8205 17.1225 40.4701 17.0504C40.1599 16.9866 39.8401 16.9866 39.53 17.0504C39.1796 17.1225 38.8487 17.3063 38.1869 17.6739L20.9203 27.2665C20.2214 27.6548 19.8719 27.8489 19.6175 28.125C19.3924 28.3693 19.222 28.6588 19.1178 28.9743C19 29.3308 19 29.7305 19 30.53V49.47C19 50.2695 19 50.6692 19.1178 51.0257C19.222 51.3411 19.3924 51.6307 19.6175 51.8749C19.8719 52.1511 20.2214 52.3452 20.9203 52.7335L38.1869 62.3261C38.8487 62.6937 39.1796 62.8775 39.53 62.9496C39.8401 63.0134 40.1599 63.0134 40.4701 62.9496C40.8205 62.8775 41.1513 62.6937 41.8131 62.3261L42.3333 62.037M29.5 22.5L50.5 34.1667M63.3333 62.1667L61 59.8333M63.3333 54C63.3333 57.866 60.1993 61 56.3333 61C52.4673 61 49.3333 57.866 49.3333 54C49.3333 50.134 52.4673 47 56.3333 47C60.1993 47 63.3333 50.134 63.3333 54Z",
    stroke: "#5498EE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 7.5,
    stroke: "black",
    strokeOpacity: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBIcon1);
export default __webpack_public_path__ + "static/media/b_icon-1.fe89069e8cf4161efb3b551a0ee94039.svg";
export { ForwardRef as ReactComponent };